import qs from 'qs';
import instance from '../axios';

export const getCurrentBatch = () => {
  return instance.get('/batch/current');
};

export const createNewBatch = () => {
  return instance.post('/batch', {});
};

export const closeBatch = (idBatch) => {
  return instance.put(`/batch/${idBatch}/close`, {});
};

export const updateBatch = (idBatch, batch) => {
  return instance.put(`/batch/${idBatch}`, batch);
}

export const retrieveBatches = () => {
  return instance.get('/batch');
}